import { useCallback } from "react";
import { TModelItem } from "../../../../../../services/api/instances/modelsApi/types";
import { useAppSelector } from "../../../../../../services/redux/hooks/use-selector";
import { selectAssistantValue } from "../../../../redux/selectors";
import { useAssistantField } from "../../../../hooks/use-assistant-field";
import { TValueForService } from "../../../../../../services/api/instances/storageApi/types/service_types";
import { ModelsSelect } from "../../../../../../common/Components/Selects/Components/ModelSelects";
import { getUpdatedValue } from "../../../../helpers/getUpdatedValue";

interface Props {
  saveAssistant: (value: TValueForService<"assistants">) => void;
}

export const AssistantModelSelect = ({ saveAssistant }: Props) => {
  const model = useAssistantField("model");
  const assistantValue = useAppSelector(selectAssistantValue);

  const handleSelectModel = useCallback(
    (model: TModelItem | null) => {
      if (!model || !assistantValue?.assistant_object) return;
      const newValue = getUpdatedValue(assistantValue, {
        model: model.id,
      });

      saveAssistant(newValue);
    },
    [model, assistantValue],
  );

  return (
    <ModelsSelect
      modelId={model ? model : "free"}
      updateObject={handleSelectModel}
    />
  );
};
